var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.item && _vm.item.lessonplan.classbook)?_c('pdf-reader',{attrs:{"src":_vm.item.lessonplan.classbook.url},model:{value:(_vm.pdfLoad),callback:function ($$v) {_vm.pdfLoad=$$v},expression:"pdfLoad"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }